/*数据映射*/
import { getQueryString } from '@/utils/tools'
let data = {
    base: {
        user: () => {
            let labelRouter = getQueryString('label');
            let user = JSON.parse(localStorage.getItem((labelRouter + "_sys_userInfo")));
            if (user == null) return {};
            let businessOption = [];
            let businessArr = [];
            for (let i in user.businessIdUser) {
                let obj = { key: user.businessIdUser[i].code, value: user.businessIdUser[i].name };
                businessOption.push(obj);
                businessArr.push(user.businessIdUser[i].code);
            }
            user.businessOption = businessOption;
            user.businessArr = businessArr;
            return user;
        },
    }
};





export default data
